<template>
  <div class="yqtj">
    <div class="yqtj-left">
      <div class="left1">
        <canvas ref="left1-cva" class="left1-cva"></canvas>
        <div class="company-name">
          {{ nameList[0] }}
        </div>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list1" :key="index" >
            <div class="left-item" @click.prevent="handleHwiperSlideClick(index)">
              <img :src="'http://119.60.27.99:9001/prod-api' + item.productImg" alt="">
              <div>
                {{ item.productName }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="left2">
        <canvas ref="left2-cva" class="left2-cva"></canvas>
        <div class="company-name">
          {{ nameList[1] }}
        </div>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list2" :key="index">
            <div class="left-item">
              <img :src="'http://119.60.27.99:9001/prod-api' + item.productImg" alt="">
              <div>
                {{ item.productName }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="left3">
        <canvas ref="left3-cva" class="left3-cva"></canvas>
        <div class="yqtjRight-itembox-swiper">
          <swiper :options="swiperOptions2">
            <swiper-slide>
              <div class="yqtjRight-itembox-image">
                <img src="../assets/images/banner1.png" alt="">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="yqtjRight-itembox-image">
                <img src="../assets/images/banner2.png" alt="">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="yqtjRight-itembox-image">
                <img src="../assets/images/banner3.png" alt="">
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="yqtj-center">
      <div class="yqtj-center-video">
        <video-player
            v-if="playerShow"
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </div>
    <div class="yqtj-right">
      <div class="right1">
        <canvas ref="right1-cva" class="right1-cva"></canvas>
        <div class="company-name">
          {{ nameList[2] }}
        </div>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list3" :key="index">
            <div class="left-item" @click="handleGoodsShow">
              <img :src="'http://119.60.27.99:9001/prod-api' + item.productImg" alt="">
              <div>
                {{ item.productName }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="right2">
        <canvas ref="right2-cva" class="right2-cva"></canvas>
        <div class="company-name">
          {{ nameList[3] }}
        </div>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list3" :key="index">
            <div class="left-item" @click="handleGoodsShow">
              <img :src="'http://119.60.27.99:9001/prod-api' + item.productImg" alt="">
              <div>
                {{ item.productName }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="right3">
        <canvas ref="right3-cva" class="right3-cva"></canvas>
        <div class="yqtjRight-itembox-swiper2">
          <swiper :options="swiperOptions3">
            <swiper-slide v-for="item in companyList" :key="item.id">
              <div class="yqtjRight-itembox-qypm" @click="skipto(item)">
                <img src="../assets/images/gs.png" alt="">
                <div>
                  {{ item.firmName }}
                </div>
                <div>
                  {{ item.address }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div v-if='companyBox'>
      <companyDetail :form="form" @handleClose='handleClose'></companyDetail>
    </div>
    <div v-if='goodsBox'>
      <goodsDetail :goods="goods" @handleClose='handleClose'></goodsDetail>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Swiper2, {Navigation, Pagination, Autoplay} from 'swiper';
Swiper2.use([Navigation, Pagination, Autoplay]);
import api from '../api/api'
import companyDetail from "@/components/companyDetail";
import goodsDetail from "@/components/goodsDetail";
export default {
  name: "homeIndex",
  components: {
    Swiper,
    SwiperSlide,
    companyDetail,
    goodsDetail
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      companyList: [],
      playerShow: false,
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: ''
        }],
        poster: '', //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          fullscreenToggle: true //全屏按钮
        }
      },
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        loop: true,
        freeMode: true,
        autoplay: {
          stopOnLastSlide: true
        },
      },
      swiperOptions2: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          stopOnLastSlide: true
        },
      },
      swiperOptions3: {
        slidesPerView: 4,
        loop: true,
        direction: 'vertical',
        autoplay: {
          stopOnLastSlide: true
        },
      },
      companyBox: false,
      form: {},
      goodsBox: false,
      goods: {},
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      nameList: []
    }
  },
  mounted() {
    this.getList();
    this.getVideoList();
  },
  methods: {
    //获取视频地址
    getVideoList() {
      api.getVideoList().then(res => {
        if (res.rows && res.rows.length > 0) {
          let src = 'http://119.60.27.99:9001/prod-api' + res.rows[0].video;
          let img = 'http://119.60.27.99:9001/prod-api'+  res.rows[0].faceImg;
          console.log(src, img);
          this.playerOptions.poster = img;
          this.playerOptions.sources[0].src = src;
          this.playerShow = true;
        }
      })
    },
    handleHwiperSlideClick(item) {
      console.log(item);
    },
    handleGoodsShow() {
      this.goodsBox = true;
    },
    // 关闭弹窗
    handleClose(){
      this.companyBox = false;
      this.goodsBox = false;
    },
    skipto(item){
      this.form = item;
      this.companyBox=true;
    },
    getList () {
      api.getMerchantList().then(res=> {
        this.companyList = res.rows;
        console.log("123res",res)
        this.list1 = res.rows[0].ltProductList;
        this.list2 = res.rows[1].ltProductList;
        this.list3 = res.rows[2].ltProductList;
        this.list4 = res.rows[3].ltProductList;
        this.nameList = res.rows.map(item => item.firmName);

        this.initCanvas(this.nameList)
      })
    },
    initCanvas(nameList) {
      let canvas1 = this.$refs["left1-cva"];
      const ctx1 = canvas1.getContext("2d");
      ctx1.moveTo(15,60);
      ctx1.lineTo(180,60);
      ctx1.lineTo(260,100);
      ctx1.lineWidth = 1;
      ctx1.strokeStyle = "#26FFCF";
      ctx1.stroke();
      ctx1.moveTo( 50, 50 );
      ctx1.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx1.font = '12px "微软雅黑"';           //设置字体
      ctx1.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx1.textAlign = "left";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx1.fillText( nameList[0], 20, 55 );        //填充文字


      let canvas2 = this.$refs["left2-cva"];
      const ctx2 = canvas2.getContext("2d");
      ctx2.moveTo(15,70);
      ctx2.lineTo(260,70);
      ctx2.lineWidth = 1;
      ctx2.strokeStyle = "#26FFCF";
      ctx2.stroke();
      ctx2.moveTo( 50, 50 );
      ctx2.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx2.font = '12px "微软雅黑"';           //设置字体
      ctx2.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx2.textAlign = "left";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx2.fillText( nameList[1], 20, 65 );        //填充文字

      let canvas3 = this.$refs["left3-cva"];
      const ctx3 = canvas3.getContext("2d");
      ctx3.moveTo(15,80);
      ctx3.lineTo(180,80);
      ctx3.lineTo(260,40);
      ctx3.lineWidth = 1;
      ctx3.strokeStyle = "#26FFCF";
      ctx3.stroke();
      ctx3.moveTo( 50, 50 );
      ctx3.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx3.font = '12px "微软雅黑"';           //设置字体
      ctx3.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx3.textAlign = "left";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx3.fillText( "企业展示", 20, 75 );        //填充文字

      let canvas4 = this.$refs["right1-cva"];
      const ctx4 = canvas4.getContext("2d");
      ctx4.moveTo(285,60);
      ctx4.lineTo(120,60);
      ctx4.lineTo(40,100);
      ctx4.lineWidth = 1;
      ctx4.strokeStyle = "#26FFCF";
      ctx4.stroke();
      ctx4.moveTo( 250, 50 );
      ctx4.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx4.font = '12px "微软雅黑"';           //设置字体
      ctx4.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx4.textAlign = "right";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx4.fillText(nameList[2], 280, 55 );        //填充文字


      let canvas5 = this.$refs["right2-cva"];
      const ctx5 = canvas5.getContext("2d");
      ctx5.moveTo(285,70);
      ctx5.lineTo(40,70);
      ctx5.lineWidth = 1;
      ctx5.strokeStyle = "#26FFCF";
      ctx5.stroke();
      ctx5.moveTo( 50, 50 );
      ctx5.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx5.font = '12px "微软雅黑"';           //设置字体
      ctx5.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx5.textAlign = "right";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx5.fillText(  nameList[3], 280, 65 );        //填充文字

      let canvas6 = this.$refs["right3-cva"];
      const ctx6 = canvas6.getContext("2d");
      ctx6.moveTo(285,80);
      ctx6.lineTo(120,80);
      ctx6.lineTo(40,40);
      ctx6.lineWidth = 1;
      ctx6.strokeStyle = "#26FFCF";
      ctx6.stroke();
      ctx6.moveTo( 50, 50 );
      ctx6.fillStyle = "#C1F3FF";               //设置填充颜色为紫色
      ctx6.font = '12px "微软雅黑"';           //设置字体
      ctx6.textBaseline = "bottom";            //设置字体底线对齐绘制基线
      ctx6.textAlign = "right";                 //设置字体对齐的方式
      //ctx.strokeText( "left", 450, 400 );
      ctx6.fillText( "企业排名", 280, 75 );        //填充文字

    },
    onPlayerPause() {
      let vm = this;
      vm.playerOptions.sources.src = '';
    },
  }
}
</script>

<style scoped lang="scss">
  .yqtj{
    color: #FFF;
    height: 100%;
    margin-bottom: 0.1rem;
    display: flex;
    justify-content: space-between;
    .company-name{
      display: none;
      font-size: 0.23rem;
      text-align: center;
    }
    .left-item{
      height: 100%;
      font-size: 0;
      text-align: center;
      img{
        margin: 0.15rem auto 0.05rem;
        font-size: 0;
        width: 0.75rem;
        height: 0.75rem;
      }
      div{
        font-size: 0.12rem;
      }
    }
    .yqtj-left{
      width: calc(25% - 0.2rem);
      padding: 0.1rem;
      display: flex;
      flex-wrap: wrap;
      .left1{
        box-sizing: border-box;
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/left1.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem 0.33rem 0.15rem 0.54rem;
        position: relative;
        .left1-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          //background: red;
          top: 0;
          right: -3rem;
        }
      }
      .left2{
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/left2.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem 0.28rem 0.15rem 0.54rem;
        box-sizing: border-box;
        position: relative;
        .left2-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          top: 0;
          right: -3rem;
        }
      }
      .left3{
        box-sizing: border-box;
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/left3.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem 0.06rem 0.15rem 0.06rem;
        position: relative;
        .left3-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          top: 0;
          right: -3rem;
        }
        .yqtjRight-itembox-swiper{
          height: calc(100% - 0.1rem);
          padding: 0.05rem;
          .swiper-container{
            height: 100%;
          }
          .yqtjRight-itembox-image{
            font-size: 0;
            height: 100%;
            img{
              width: 100%;
              height: 100%;
              //object-fit: contain;
            }
          }
        }
      }

    }
    .yqtj-center{
      width: 50%;
      padding: 0.2rem 0.1rem 0.2rem 0rem;
      .yqtj-center-video{
        height: 100%;
        margin: 0 auto;
        width: calc(100% - 4rem);
        display: flex;
        align-items: center;
        position: relative;
        z-index: 1;
        .video-player{
          width: 100%;
          padding: 0.2rem;
          ::v-deep .video-js{
            width: 100% !important;
            height: auto !important;
          }
          ::v-deep .vjs-big-play-button{
            left: calc(50% - 45px);
            top: calc(50% - 20px);
          }
        }
      }
    }
    .yqtj-right{
      width: calc(25% - 0.2rem);
      padding: 0.1rem;
      .right1{
        box-sizing: border-box;
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/right1.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem  0.54rem 0.15rem 0.33rem;
        position: relative;
        .right1-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          top: 0;
          left: -3rem;
        }
      }
      .right2{
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/right2.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem 0.54rem 0.15rem 0.28rem;
        box-sizing: border-box;
        position: relative;
        .right2-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          top: 0;
          left: -3rem;
        }
      }
      .right3{
        box-sizing: border-box;
        width: 100%;
        height: 33.33%;
        background: url("../assets/images/right3.png")no-repeat;
        background-size: 100% 100%;
        padding: 0.15rem 0.74rem 0.15rem 0.5rem;
        position: relative;
        .right3-cva{
          position: absolute;
          height: 100%;
          width: 3rem;
          top: 0;
          left: -3rem;
        }
        .yqtjRight-itembox-swiper2{
          height: 100%;
          .swiper-container{
            height: 100%;
          }
          .yqtjRight-itembox-qypm{
            height: 100%;
            font-size: 0.1rem;
            display: flex;
            align-items: center;
            img{
              width: 0.2rem;
              margin-right: 0.1rem;
            }
            div:nth-of-type(1) {
              width: calc(60% - 0.35rem);
            }
            div:nth-of-type(2) {
              width: 40%;
              text-align: right;
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1920px) {
    .yqtj{
      .company-name{
        display: block;
        font-size: 0.23rem;
        text-align: center;
      }
      .yqtj-left{
        width: 30%;
        padding: 0.2rem 0.1rem 0.2rem 0.1rem;
        .left1{
          height: 25%;
          padding: 0.35rem 0.33rem 0.15rem 0.54rem;
          .left1-cva{
            display: none;
          }
          .left-item{
            width: 100%;
            img{
              width: 90%;
              margin: 0.1rem auto 0.1rem;
            }
          }
        };
        .left2{
          height: 25%;
          padding: 0.35rem 0.28rem 0.15rem 0.54rem;
          .left2-cva{
            display: none;
          }
          .left-item{
            width: 100%;
            img{
              width: 90%;
              margin: 0.1rem auto 0.1rem;
            }
          }
        }
        .left3{
          height: 25%;
          padding: 0.25rem 0.06rem 0.25rem 0.06rem;
          .left3-cva{
            display: none;
          }
        }
      }
      .yqtj-center{
        width: 40%;
        text-align: center;
        padding: 0.2rem 0;
        .yqtj-center-video{
          width: 100%;
        }
      }
      .yqtj-right{
        width: calc(30% - 0.2rem);
        padding: 0.2rem 0.1rem 0.2rem 0.1rem;
        display: flex;
        flex-wrap: wrap;
        .right1{
          height: 25%;
          padding: 0.35rem 0.54rem 0.15rem 0.33rem ;
          .right1-cva{
            display: none;
          }
          .left-item{
            width: 100%;
            img{
              width: 90%;
              margin: 0.1rem auto 0.1rem;
            }
          }
        };
        .right2{
          height: 25%;
          padding: 0.35rem 0.54rem  0.15rem 0.28rem;
          .right2-cva{
            display: none;
          }
          .left-item{
            width: 100%;
            img{
              width: 90%;
              margin: 0.1rem auto 0.1rem;
            }
          }
        }
        .right3{
          height: 25%;
          padding: 0.25rem 0.74rem 0.25rem 0.5rem;
          .right3-cva{
            display: none;
          }
        }
      }
    }

  }
</style>
